/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordRelayHistoryMessageItem
 */
export interface DiscordRelayHistoryMessageItem {
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayHistoryMessageItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayHistoryMessageItem
     */
    channelId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayHistoryMessageItem
     */
    guildId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordRelayHistoryMessageItem
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscordRelayHistoryMessageItem
     */
    timestamp?: Date;
    /**
     * 
     * @type {object}
     * @memberof DiscordRelayHistoryMessageItem
     */
    author?: object;
}

/**
 * Check if a given object implements the DiscordRelayHistoryMessageItem interface.
 */
export function instanceOfDiscordRelayHistoryMessageItem(value: object): value is DiscordRelayHistoryMessageItem {
    return true;
}

export function DiscordRelayHistoryMessageItemFromJSON(json: any): DiscordRelayHistoryMessageItem {
    return DiscordRelayHistoryMessageItemFromJSONTyped(json, false);
}

export function DiscordRelayHistoryMessageItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayHistoryMessageItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'channelId': json['channelId'] == null ? undefined : json['channelId'],
        'guildId': json['guildId'] == null ? undefined : json['guildId'],
        'content': json['content'] == null ? undefined : json['content'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'author': json['author'] == null ? undefined : json['author'],
    };
}

export function DiscordRelayHistoryMessageItemToJSON(json: any): DiscordRelayHistoryMessageItem {
    return DiscordRelayHistoryMessageItemToJSONTyped(json, false);
}

export function DiscordRelayHistoryMessageItemToJSONTyped(value?: DiscordRelayHistoryMessageItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'channelId': value['channelId'],
        'guildId': value['guildId'],
        'content': value['content'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'author': value['author'],
    };
}

